import { getCities, getPlans } from '../../api/authApi'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { setActiveCitiesAction } from '../../store/city/action'
import { setPlansAction } from '../../store/global/action'
import styles from './index.module.less'
import { Card, Space } from 'antd'
import { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { compose } from 'redux'

const CouponTemplatesContainer = (props: ConnectedProps<typeof withConnect>) => {
  const location = useLocation()

  useEffect(() => {
    getCities().then(res => {
      const { setActiveCitiesAction } = props
      setActiveCitiesAction(res)
    })

    Promise.all([
      getPlans({ page: 0, size: 999, type: 3 }),
      getPlans({ page: 0, size: 999, type: 4 }),
    ]).then(planResponses => {
      const { setPlansAction } = props
      const miniProgramSelectablePlan = planResponses
        .flatMap(response => response.data)
        .filter((item: any) => item.miniProgramSelectable)
      setPlansAction(miniProgramSelectablePlan)
    })
  }, [])

  const getNavBarTitle = () => {
    const pathName = location.pathname

    if (pathName.match(/^\/coupon-templates\/[0-9]+\/duplicate$/)) {
      return translate('navBar.newCouponTemplate')
    }

    if (pathName.match(/^\/coupon-templates\/[0-9]+\/edit$/)) {
      return translate('navBar.editCouponTemplate')
    }

    if (pathName.match(/^\/coupon-templates\/new/)) {
      return translate('navBar.newCouponTemplate')
    }

    if (pathName.match(/^\/coupon-templates\/[0-9]+$/)) {
      return translate('navBar.viewCouponTemplate')
    }

    return translate('navBar.couponTemplatesTitle')
  }

  return (
    <Space className={styles['dashboard-wrapper']} orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

const mapDispatchToProps = {
  setActiveCitiesAction,
  setPlansAction,
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(CouponTemplatesContainer)
